/* eslint-disable import/prefer-default-export */
import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  wrapper: {
    backgroundColor: '#fafafa',
  },
  container: {
    padding: '80px 0 88px',
    color: '#1C1C1C',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    color: '#1c1c1c',
    textAlign: 'center',
    fontFamily: "'Noto Sans JP'",
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '56px',
    margin: 0,
  },
  innerBlock: {
    width: 780,
    marginTop: 50,
    marginBottom: 84,
    '@media (max-width: 1024px)': {
      width: '100%',
    },
  },
  innerLinksBlock: {
    margin: '68px 0',
    display: 'flex',
    width: '600px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    '@media (max-width: 1024px)': {
      width: '100%',
      padding: '0 16px',
    },
  },
  accordion: {
    margin: '0 !important',
    borderBottom: '1px solid #C4BCB5',
    boxShadow: 'none',

    '&:before': {
      display: 'none',
    },
  },
  summary: {
    backgroundColor: '#fafafa',
    padding: '0 26px',

    '&:not(:first-child)': {},
  },
  summaryContent: {
    margin: '32px 0 !important',
  },
  details: {
    background: '#f0f0f0',
    padding: '32px 46px',
    font: `400 16px/24px ${theme.typography.fontFamily}`,
    color: '#404042',
    '& > p a': {
      color: '#e5258c',
      fontWeight: 400,
      textDecoration: 'underline',
    },
  },
  cq: {
    alignItems: 'center',
    backgroundColor: '#E6E1DC',
    borderRadius: '50%',
    color: '#1C1C1C',
    display: 'flex',
    font: `400 16px/16px ${theme.typography.fontFamily}`,
    height: 30,
    justifyContent: 'center',
    marginRight: 16,
    paddingBottom: 4,
    width: 30,
    '@media (max-width: 1024px)': {
      paddingRight: 8,
      paddingLeft: 8,
    },
  },
  heading: {
    font: `700 18px/32px ${theme.typography.fontFamily}`,
    '@media (max-width: 1024px)': {
      font: `700 16px/32px ${theme.typography.fontFamily}`,
    },
  },
  linkWrapper: {
    display: 'flex',
    width: '503px',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: '10%',
    '@media (max-width: 1024px)': {
      width: '100%',
      marginLeft: 0,
    },
  },
  link: {
    display: 'flex',
    padding: '24px 16px',
    alignItems: 'flex-start',
    gap: '20px',
    alignSelf: 'stretch',
    width: 500,
    '@media (max-width: 1024px)': {
      width: '100%',
    },
  },
  line: {
    width: '503px',
    height: '1px',
    background: '#EEF0F2',
    '@media (max-width: 1024px)': {
      width: '100%',
    },
  },
  linkQuestion: {
    color: '#1C1C1C',
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: '"Noto Sans JP"',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '32px',
    letterSpacing: '0.415px',
    flex: '1 0 0',
  },
  linkArrow: {
    width: '24px',
    height: '24px',
  },
  bottomLink: {
    color: '#e30e80',

    /* Button/Text Button */
    fontFamily: "'Hiragino Sans'",
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '22px' /* 157.143% */,
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'auto',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',
  },
  linkNpayQuestion: {
    fontFamily: 'Hiragino Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    flex: '1 0 0',
    color: '#1C1C1C',
    textDecoration: 'none',
    '&:hover': {
      color: '#1C1C1C',
    },
    '&:visited': {
      color: '#1C1C1C',
    },
  },
  titleNpay: {
    color: '#1c1c1c',
    textAlign: 'center',
    fontFamily: "'Noto Sans JP'",
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '56px',
    display: 'flex',
    paddingTop: '48px',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '48px',
    alignSelf: 'stretch',
    '@media (max-width: 600px)': {
      fontSize: '26px',
      lineHeight: '36px',
    },
  },
}));
